import React, { useState } from "react";
import { Alert } from "reactstrap";
import { Btn, P } from "../../../AbstractElements";

export const TypeaheadAlert = () => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);
  return (
    <Alert fade color="light-primary" className="txt-primary alert-dismissible show" role="alert" isOpen={visible}>
      <i data-feather="alert-triangle"></i>
      <P>
        This is the Typeahead page where <strong>jQuery </strong> was utilised.
      </P>
      <Btn className="btn-close" onClick={onDismiss}></Btn>
    </Alert>
  );
};
